<template>
  <div v-if="unloadedProducts">
    <div class="info-bar-back">
      {{$t('shopfloor.teamlead.unloading.reference')}} <span class="text-dark ml-2">{{getCargo(id).reference}}</span>
      <router-link tag="a" :to="{name:'teamlead-cargos-unloading'}" class="float-right">
        Terug
      </router-link>
    </div>
    <table class="table table-striped unloading-cargo-overview">
      <thead>
      <tr>
        <th>{{$t('shopfloor.teamlead.unloading.articleNr')}}</th>
        <th>{{$t('shopfloor.teamlead.unloading.location')}}</th>
        <th>{{$t('shopfloor.teamlead.unloading.startTime')}}</th>
        <th>{{$t('shopfloor.teamlead.unloading.endTime')}}</th>
        <th>{{$t('shopfloor.teamlead.unloading.employee')}}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(product, index) in getProductsFromCargo(id)" :key="index">
        <td>{{product.productNumber}}</td>
        <td><i v-if="product.locationName" class="fad fa-warehouse-alt mr-3"/> {{product.locationName}}</td>
        <td><i v-if="product.startTime" class="fad fa-clock mr-3"/>{{formatTime(product.startTime)}}</td>
        <td><i v-if="product.endTime" class="fad fa-clock mr-3"/> {{formatTime(product.endTime)}}</td>
        <td> {{product.userName}}</td>
      </tr>

      </tbody>
    </table>

  </div>
</template>


<script>
  import {mapGetters} from 'vuex';


  export default {
    props: ['id'],
    data() {
      return {
        unloadedProducts: []
      };
    },
    firestore() {
      return {
        unloadedProducts: this.$FB.collection('incoming-products')
            .where('companyId', '==', this.getMeBasic.companyId)
            .where('product.cargoId', '==', parseInt(this.id))
      };
    },
    computed: {
      ...mapGetters('orderProducts', ['getProductsFromCargo']),
      ...mapGetters('cargo', ['getCargo']),
      ...mapGetters(['getAPICompanyID']),
      ...mapGetters('users', [
        'getMeBasic'
      ]),
      orderUnloadedProducts() {
        let products = this.unloadedProducts;

        return products.sort(function compare(a, b) {
          let dateA = new Date(a.startTime.seconds * 1000);
          let dateB = new Date(b.startTime.seconds * 1000);
          return dateB - dateA;
        });
      }
    },
    methods: {
      formatTime(time) {
        return !time ? '' : moment(time.toDate()).format('HH:mm');

      }
    },
    async beforeRouteLeave(from, to, next) {
      await this.$store.dispatch('cargo/closeDBChannel');
      await this.$store.dispatch('orderProducts/closeDBChannel');
      this.unloadedProducts.destroy()
      next();
    },
    async created() {
      let where = [
        ['companyId', '==', parseInt(this.getAPICompanyID)],
        ['cargoType', '==', 'incoming']
      ];
     await  this.$store.dispatch('cargo/openDBChannel', {where});
        where = [
        ['companyId', '==', parseInt(this.getAPICompanyID)],
        ['cargoId', '==', parseInt(this.id)]
      ];
     await  this.$store.dispatch('orderProducts/openDBChannel', {where});
    }
  };
</script>